import React from 'react'
import PropTypes from 'prop-types'
import css from './styles.css'

const Footer = ({ sent, pending, total }) => {
  const countItems = [
    { css: css.left,   label: 'sent',    value: sent },
    { css: css.center, label: 'pending', value: pending },
    { css: css.right,  label: 'total',   value: total },
  ]

  return (
    <div className={css.footer}>
      {
        countItems.map(({ css, label, value }) => (
          <div key={label} className={css}>
            <h3>{label}</h3>
            <h1>{value}</h1>
          </div>
        ))
      }
    </div>
  )
}

Footer.propTypes = {
  sent: PropTypes.number.isRequired,
  pending: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/SelectedBlast/Footer.js